module.exports = __webpack_public_path__ + "static/media/12.016ba8d5.jpg";